/* eslint-disable */
import { useState, useEffect, useContext, useCallback } from 'react';
import './techSession.scss';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ReactComponent as ListView } from '../../../Assets/images/svg/dar_list_view.svg';
import { ReactComponent as CalenderView } from '../../../Assets/images/svg/dar_calender_view.svg';
import { TECH_SESSION_PAGE, TECH_SESSION_SEND_EMAIL } from '../../../Constants/strings';
import TechSessionCalendarView from './techSessionCalender';
import { getUsersData, hasAccess } from './UserListView/customUtil';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import SearchBar from './UserListView/searchBar';
import ActionButtons from './UserListView/actionButton'
import UserDataGrid from './UserListView/userDataGrid';
import { TECH_SESSION_FIELDS, TECH_SESSION_HEADER } from '../../../Constants/strings';
import useUsers from './UserListView/userUsers';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';
import { CircularProgress } from '@mui/material';
import { lazy, Suspense } from 'react';
import puzzleLoader from '../../../Assets/images/svg/loading puzzle.gif';
import SendEmailConfirmationDialog from './UserListView/CustomizedEmail/sendEmailConfirmationDialog';
const CustomizedEmailDialog = lazy(() => import('./UserListView/CustomizedEmail/customizedEmailDialog'));
const GenericEmailDialog = lazy(() => import('./UserListView/CustomizedEmail/genericEmailDialog'));
import { Checkbox } from '@mui/material';
const TechSession = () => {
  const [view, setView] = useState('calender');
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { snackbarOpen } = useSnackbar();
  const [isMobileView, setIsMobileView] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const [anchorEl, setAnchorEl] = useState({});
  const { userProfile } = useContext(AuthContext);
  const { rows, setRows } = useUsers();
  const [isDataEdit, setIsDataEdit] = useState(false);
  const permissions = userProfile?.permissions?.[MODULE_NAMES.CONFIGURATION_USER] || [];
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [emailType, setEmailType] = useState('');
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [emailMenuAnchorEl, setEmailMenuAnchorEl] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [lastClickedUser, setLastClickedUser] = useState(null);

    const permission = userProfile?.permissions
      ? userProfile.permissions[MODULE_NAMES.TECH_SESSION_NEW_REQUEST] || []
      : [];
  const handleEmailSent = () => {
    setSelectedRows([]);
  };

  const handleEmailButtonClick = (event) => {
    setEmailMenuAnchorEl(event.currentTarget);
  };

  const handleEmailMenuClose = () => {
    setEmailMenuAnchorEl(null);
  };

  const handleGenericEmail = () => {
    setEmailType('generic');
    setConfirmOpen(true);
    handleEmailMenuClose();
  };

  const handleCustomizeEmail = () => {
    setEmailType('customize');
    setConfirmOpen(true);
    handleEmailMenuClose();
  };

  const handleConfirmDialogClose = () => {
    setConfirmOpen(false);
  };

  const handleCloseEmailDialog = () => {
    setEmailModalOpen(false);
  };

  const handleCloseGenericDialog = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    if (view) {
      fetchUsers();
    }
  }, [view]);

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      await getUsersData(setUsers, snackbarOpen);
    } catch (err) {
      setError('Failed to fetch users');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
    setIsLaptopView(window.innerWidth >= 1024 && window.innerWidth <= 1500);
  };
  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  // Add function to handle checkbox selection change
  const handleRowSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);

  };
  const handleActionClick = useCallback((event, rowId) => {
    setAnchorEl((prev) => ({ ...prev, [rowId]: event.currentTarget }));
    setIsDataEdit(true);
  }, []);
  const handleConfirmSendEmail = () => {
    setConfirmOpen(false); 
    if (emailType === 'generic') {
      setDialogOpen(true);
      setEmailModalOpen(false); 
    } else if (emailType === 'customize') {
      setEmailModalOpen(true); 
      setDialogOpen(false); 
    }
  };

  const handleSendClick = () => {
    console.log('Send button clicked for:');
    // Add your send logic here
  };
  const getColumnWidth = (mobile, laptop, defaultWidth) => {
    if (isMobileView) {
      return mobile;
    } else if (isLaptopView) {
      return laptop;
    }
    return defaultWidth;
  };
  const getColumnFlex = (defaultFlex) => {
    if (!isMobileView && !isLaptopView) {
      return defaultFlex;
    }
    return undefined;
  };

  const handleCloseMenu = useCallback((rowId) => {
    setAnchorEl((prev) => ({ ...prev, [rowId]: null }));
    setIsDataEdit(false);
  }, []);


const filteredRows = searchText.length >= 1
  ? rows.filter((row) => {
      const lowerSearch = searchText.toLowerCase();
      return (
        row.employeeId.toLowerCase().includes(lowerSearch)
        || row.fullName.toLowerCase().includes(lowerSearch)
        || row.emailId.toLowerCase().includes(lowerSearch)
        || row.location.toLowerCase().includes(lowerSearch)
        || row.vertical.toLowerCase().includes(lowerSearch)
        || row.department.toLowerCase().includes(lowerSearch)
        || row.designation.toLowerCase().includes(lowerSearch)
        || row.roleNames.toLowerCase().includes(lowerSearch)
        || row.projectAllocation.toLowerCase().includes(lowerSearch)
      );
    })
  : rows;

const allSelected = rows.length > 0 && selectedRows.length === rows.length;

  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      setSelectedRows(filteredRows.map(row => row.id));
    } else {
      setSelectedRows([]);
    }
  };
  const columns = [
    {
      field: 'select',
      headerName: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          <Checkbox
            checked={allSelected}
            onChange={handleSelectAllChange}
            style={{ padding: 0, marginRight: 4 }}
            disabled={!hasAccess('create',permission)}
          />
          <span style={{ whiteSpace: 'nowrap', flexShrink: 0, fontSize: '15px',color: '#7A757F', }}>Select all</span>
        </div>
      ),
      width: 120,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Checkbox
          checked={selectedRows.includes(params.row.id)}
          onChange={() => handleRowCheckboxChange(params.row.id)}
          style={{ padding: 0 }}
          inputProps={{ 'aria-label': `Select user ${params.row.id}` }} 
          disabled={!hasAccess('create',permission)}
        />
      ),
      headerClassName: 'MuiDataGrid-columnHeader',
      cellClassName: 'MuiDataGrid-cell',
    },
    {
      field: TECH_SESSION_FIELDS.USER_ID,
      headerName: TECH_SESSION_HEADER.ID,
      minWidth: 120,
      flex: 0.12,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'MuiDataGrid-columnHeader',
      cellClassName: 'MuiDataGrid-cell',
    },
    {
      field: TECH_SESSION_FIELDS.NAME,
      headerName: TECH_SESSION_HEADER.NAME,
      minWidth: 220,
      flex: 0.16,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'MuiDataGrid-columnHeader',
      cellClassName: 'MuiDataGrid-cell',
    },
    {
      field: TECH_SESSION_FIELDS.EMAIL,
      headerName: TECH_SESSION_HEADER.EMAIL,
      minWidth: 330,
      flex: 0.22,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'MuiDataGrid-columnHeader',
      cellClassName: 'MuiDataGrid-cell',
    },
    {
      field: TECH_SESSION_FIELDS.VERTICAL,
      headerName: TECH_SESSION_HEADER.VERTICAL,
      minWidth: 170,
      flex: 0.13,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'MuiDataGrid-columnHeader',
      cellClassName: 'MuiDataGrid-cell',
    },
    {
      field: TECH_SESSION_FIELDS.DEPARTMENT,
      headerName: TECH_SESSION_HEADER.DEPARTMENT,
      minWidth: 210,
      flex: 0.11,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'MuiDataGrid-columnHeader',
      cellClassName: 'MuiDataGrid-cell',
    },
    {
      field: TECH_SESSION_FIELDS.DESIGNATION,
      headerName: TECH_SESSION_HEADER.DESIGNATION,
      minWidth: 350,
      flex: 0.14,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'MuiDataGrid-columnHeader',
      cellClassName: 'MuiDataGrid-cell',
    },
    {
      field: TECH_SESSION_FIELDS.ALLOCATION,
      headerName: TECH_SESSION_HEADER.ALLOCATION,
      minWidth: 250,
      flex: 0.12,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'MuiDataGrid-columnHeader',
      cellClassName: 'MuiDataGrid-cell',
    },
  ];
  const handleRowCheckboxChange = (rowId) => {
    setSelectedRows((prevSelected) => {
      let newSelected;
      if (prevSelected.includes(rowId)) {
        newSelected = prevSelected.filter((id) => id !== rowId);
      } else {
        newSelected = [...prevSelected, rowId];
      }

      // Update lastClickedUser logic
      if (newSelected.includes(rowId)) {
        const user = rows.find(row => row.id === rowId);
        setLastClickedUser(user);
      } else {

        if (lastClickedUser && lastClickedUser.id === rowId) {
          const lastUserId = newSelected.length > 0 ? newSelected[newSelected.length - 1] : null;
          const user = rows.find(row => row.id === lastUserId);
          setLastClickedUser(user || null);
        }
      }

      return newSelected;
    });
  };

  return (
    <div className="tech-sessions-container">
      <div className="tech-session-header">
        <div className="tech-session-title">
          {TECH_SESSION_PAGE.USER_HEADER}
        </div>
        {loading ? (
          <div className="tech-session-loader">
            <img src={puzzleLoader} alt="Loading..." className="loader-gif" />
          </div>
        ) : error ? (
          <div>{error}</div>
        ) : (
          <div className="tech-session-users-manage-outer-layer">
            <div className="tech-session-users-manage">
              <div className="tech-session-users-search-and-buttons">
                <SearchBar searchText={searchText} handleSearch={handleSearch} />
                <ActionButtons
                  selectedRows={selectedRows}
                  onGenericEmail={handleGenericEmail}
                  onCustomizeEmail={handleCustomizeEmail}
                  anchorEl={emailMenuAnchorEl}
                  handleButtonClick={handleEmailButtonClick}
                  handleClose={handleEmailMenuClose}
                  disabled={selectedRows.length === 0}
                />
              </div>
              <UserDataGrid
                filteredRows={filteredRows}
                columns={columns}
                handleRowSelectionChange={handleRowSelectionChange}
                dataColumns={columns}
                allSelected={allSelected}
                onSelectAllChange={handleSelectAllChange}
                selectedRow={selectedRows}
                checkboxHeaderLabel="Select all"
                hideSeparator={true}
              />
            </div>
          </div>
        )}
      </div>

      <SendEmailConfirmationDialog
        open={confirmOpen}
        onClose={handleConfirmDialogClose}
        onConfirm={handleConfirmSendEmail}
        emailType={emailType}
      />
      <Suspense fallback={<div style={{textAlign:'center',marginTop:40}}><CircularProgress size={32} /></div>}>
        {emailModalOpen && (
          <CustomizedEmailDialog
            modalOpen={emailModalOpen}
            handleClose={handleCloseEmailDialog}
            emailType={emailType}
            selectedUsers={selectedRows.map(id => rows.find(row => row.id === id))}
            selectedEmails={selectedRows.map(id => rows.find(row => row.id === id)?.emailId).filter(Boolean)}
            lastUpdatedBy={userProfile?.user_name}
            onEmailSent={handleEmailSent}
            hostId={selectedRows.length > 0 ? selectedRows.map(id => rows.find(row => row.id === id)?.employeeId).filter(Boolean) : []}
            currentUser={lastClickedUser}
          />
        )}
        {dialogOpen && (
          <GenericEmailDialog
            modalOpen={dialogOpen}
            handleClose={handleCloseGenericDialog}
            emailType={emailType}
            selectedEmails={selectedRows.map(id => rows.find(row => row.id === id)?.emailId).filter(Boolean)}
            onEmailSent={handleEmailSent}
          />
        )}
      </Suspense>
    </div>
  );
};

export default TechSession;
    